<template>
  <div class="product-price-panel-page row-block" :style="{ height: minHeight || '100%' }">
    <div v-if="datas.length" class="main-container col-block" :class="[state]">
      <div class="tab-block">
        <tabButtons
          :state="state"
          :options="tabOptions"
          @change="s => state = s"
        ></tabButtons>
      </div>
      <div v-show="state === 'graph'" class="main-block" :style="{ flex: 1 }">
        <productPriceGraph
          :datas="datas"
          :filterOptions="filterOptions"
          :conditions="conditions"
        ></productPriceGraph>
      </div>
      <div v-show="state === 'table'" class="main-field" :style="{ flex: 1, 'min-width': '1330px' }">
        <div class="main-block">
          <productPriceTable
            v-if="rolePermission(['advance', 'admin'])"
            :update="update"
          ></productPriceTable>
        </div>
      </div>
    </div>
    <div v-else class="tutorial-container container-block">
      <productPriceTutorial></productPriceTutorial>
    </div>
  </div>
</template>

<script>
import productPriceTable from '../productPrice/table'
import productPriceGraph from '../productPrice/graph'
import productPriceTutorial from '../productPrice/tutorial'
import tabButtons from '../tool/tabButtons'
import userPermission from '../../mixins/userPermission'

export default {
  components: {
    productPriceTable,
    productPriceGraph,
    productPriceTutorial,
    tabButtons
  },
  mixins: [
    userPermission
  ],
  props: {
    minHeight: {
      type: String,
      default: () => null
    },
    datas: {
      type: Array,
      required: true
    },
    filterOptions: {
      type: Object,
      required: true
    },
    conditions: {
      type: Object,
      required: true
    },
    update: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      state: 'graph',
      tableDatas: [],
      selectedDatas: []
    }
  },
  computed: {
    tabOptions () {
      return [
        {
          title: '統計圖呈現',
          value: 'graph'
        },
        ...this.rolePermission(['advance', 'admin']) ? [
          {
            title: '上傳紀錄',
            value: 'table'
          }
        ] : []
      ]
    }
  },
  watch: {
    'datas' () {
      this.state = 'graph'
    },
    'state' (nv) {
      this.$emit('changeState', nv)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/productPrice/panel.vue